// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"532":"pastelero","550":"pedidos"}[chunkId] + "." + {"532":"0fb13426","550":"d8fb4063"}[chunkId] + ".css";
};